import React                           from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster }                     from "react-hot-toast";
import { AuthProvider, useAuth }       from "./context/AuthContext";

// Pages — we will create these files next
import LandingPage    from "./pages/LandingPage";
import AdminLogin     from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

// ─── Protects /admin route ────────────────────────────────────
// If not logged in → redirects to login page automatically
function ProtectedRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/staff-portal-1464" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      {/* Toast notifications (success / error popups) */}
      <Toaster position="top-right" />

      <BrowserRouter>
        <Routes>
          {/* Public website — customers visit this */}
          <Route path="/"            element={<LandingPage />} />

          {/* Admin login page */}
          <Route path="/staff-portal-1464" element={<AdminLogin />} />

          {/* Admin dashboard — only accessible when logged in */}
          <Route path="/admin/*" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }/>

          {/* Any unknown URL → go back to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}